import { render, staticRenderFns } from "./ns-product-variant-selector-vue.vue?vue&type=template&id=c16e164a&scoped=true&"
import script from "./ns-product-variant-selector-vue.vue?vue&type=script&lang=js&"
export * from "./ns-product-variant-selector-vue.vue?vue&type=script&lang=js&"
import style0 from "./ns-product-variant-selector-vue.vue?vue&type=style&index=0&id=c16e164a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16e164a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c16e164a')) {
      api.createRecord('c16e164a', component.options)
    } else {
      api.reload('c16e164a', component.options)
    }
    module.hot.accept("./ns-product-variant-selector-vue.vue?vue&type=template&id=c16e164a&scoped=true&", function () {
      api.rerender('c16e164a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/ns-shop-elements/src/ns-product-variant-selector-vue/ns-product-variant-selector-vue.vue"
export default component.exports